export { default as DefaultLayout } from "containers/DefaultLayout";
export { default as DefaultView } from "containers/DefaultLayout/DefaultView";
export { default as NotFound } from "containers/DefaultLayout/NotFound";
export { default as CurtainReveal } from "containers/DefaultLayout/CurtainReveal";
